/** Job postings mobile carousel: animated shift-req + inert on off-screen slides. */

export const initJobPostingShiftReq = (container) => {
    container?.querySelectorAll('.carousel__slide:not(:first-child)').forEach((slide) => {
        const element = slide.querySelector('.job-postings-shift-req');
        if (!element) return;

        element.classList.remove('sr--prep', 'sr--in');
        element.classList.add('sr--hidden');
        element.setAttribute('aria-hidden', 'true');
    });
};

export const revealShiftReq = (container, slide) => {
    if (!container.matches('#job-postings-row .carousel--mobile-only') || !slide) return;

    const element = slide.querySelector('.job-postings-shift-req');
    if (!element?.matches('.sr--hidden, .sr--prep')) return;

    element.classList.remove('sr--hidden', 'sr--in');
    element.classList.add('sr--prep');

    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            element.classList.remove('sr--prep');
            element.classList.add('sr--in');
            element.removeAttribute('aria-hidden');
        });
    });
};

export const syncJobPostingSlideInert = (slides, carouselActive) => {
    slides.forEach((slide) => {
        slide.toggleAttribute('inert', carouselActive && !slide.classList.contains('is-active'));
    });
};
